<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { onMounted } from 'vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import { useUserStore } from '@/stores/user'
import { getUserInfo } from '@/api/auth'
import { useI18n } from '@/composables/useI18n'

const userStore = useUserStore()
const { locale } = useI18n()

const elementLocale = computed(() => (locale === 'zh-CN' ? zhCn : en))

onMounted(async () => {
  // Fetch user info if token exists
  if (userStore.token && !userStore.userInfo) {
    try {
      const info = await getUserInfo()
      userStore.setUserInfo(info)
    } catch (e) {
      // Token invalid, logout
      userStore.logout()
    }
  }
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
}
</style>
